import { Outlet } from 'react-router-dom';
import { FronteggProvider, FronteggThemeOptions } from '@frontegg/react';
import { useAppAuth } from './hooks/useAppAuth';
import AuthService from './services/auth.service';
import { PliableAuthProvider } from './contexts/PliableAuthContext';

const authService = AuthService.getInstance();

const contextOptions = {
  baseUrl: authService.authUrl,
  clientId: authService.feClientId,
  appId: authService.feAppId,
};

const authOptions = {
  keepSessionAlive: true,
  routes: {
    loginUrl: authService.useExternalLogin ? '/ext-login' : '/login',
    logoutUrl: '/do/logout',
    authenticatedUrl: '/',
  },
};

const themeOptions: FronteggThemeOptions = {
  loginBox: {},
};

// ─── App Content (shared between both providers) ─────────────────────────────

function AppContent() {
  const { isLoading, isAuthenticated } = useAppAuth();

  if (authService.useExternalLogin && isAuthenticated) {
    window.location.href = authService.authAppUrl;
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  return <Outlet />;
}

// ─── App (switches provider based on OIDC mode) ─────────────────────────────

function App() {
  if (authService.oidcEnabled) {
    return (
      <PliableAuthProvider>
        <AppContent />
      </PliableAuthProvider>
    );
  }

  return (
    <FronteggProvider
      authOptions={authOptions}
      contextOptions={contextOptions}
      themeOptions={themeOptions}
      hostedLoginBox={false}
      entitlementsOptions={{ enabled: true }}
    >
      <AppContent />
    </FronteggProvider>
  );
}

export default App;
